import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  QueryList,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  ActivatedRoute,
  NavigationEnd,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import * as Waves from 'node-waves';
import {
  BehaviorSubject,
  Subject,
  Subscription,
  asyncScheduler,
  catchError,
  combineLatest,
  filter,
  finalize,
  interval,
  map,
  observeOn,
  of,
  take,
  takeUntil,
} from 'rxjs';
import { CoreMenuService } from 'src/@core/components/core-menu/core-menu.service';
import { CoreSidebarService } from 'src/@core/components/core-sidebar/core-sidebar.service';
import { CoreConfigService } from 'src/@core/services/config.service';
import { CoreLoadingScreenService } from 'src/@core/services/loading-screen.service';
import { CoreConfig, CoreMenu } from 'src/@core/types';
import { environment } from 'src/environments/environment.development';
import { DataService } from './helpers/data.service';
import { iCommentsRequest } from './helpers/Interfaces/comments';
import { iDueTaskDto } from './helpers/Interfaces/task';
import { hr360Menu } from './menu/hr360.menu';
import { iTeamMenu } from './menu/i-team.menu';
import { leadKonnektMenu } from './menu/lead-konnekt.menu';
import { setupMenu } from './menu/setup.menu';
import { AuthService } from './modules/app/auth/auth.service';
import { TasksService } from './modules/i-team/tasks/tasks.service';
import { MatDialog } from '@angular/material/dialog';
import { ReminderModalComponent } from './modules/hr360/TODos/reminder-modal/reminder-modal.component';
import { TodosService } from './modules/hr360/TODos/todos.service';
import { Todo } from 'src/app/helpers/Interfaces/todo';
import { iReleaseNotesResponse } from './helpers/Interfaces/release-notes';
import { ReleaseNotesGateService, ReleaseNotesUiService } from './modules/i-team/release-notes/release-notes-gate.service';
import { invoicingMenu } from './menu/easy-invoicing.menu';
import { iNestMenu } from './menu/i-nest.menu';
import { customerPortalMenu } from './menu/customer-portal.menu';
import { movementDiaryMenu } from './menu/movement-diary.menu';
import { WorkspaceService } from './modules/setup/workspace/workspace.service';
import { OnboardingService } from './services/onboarding.service';

@Component({
  selector: 'app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('dueTasksModal') public dueTasksModal!: TemplateRef<any>;
  @ViewChild('releaseNotesModal') public releaseNotesModal!: TemplateRef<any>;
  @ViewChild('workspaceExpiryModal') public workspaceExpiryModal!: TemplateRef<any>;
  @ViewChildren('stepItem') stepItems!: QueryList<ElementRef>;

  protected workspaceExpiry: any = null;
  protected workspaceExpiryTimeStr: string = '';
  protected workspaceExpiryDate: any = null;
  protected isWorkspaceExpired: boolean = false;
  private workspaceExpiryModalRef: any;
  protected workspaceExpiryActive: boolean = false;
  protected workspaceExpiryBannerVisible: boolean = true;
  protected workspaceExpiryMessage: string = '';

  coreConfig!: CoreConfig;
  menu!: CoreMenu[];
  protected dueTaskLoading: boolean = false;
  protected dueTasks: any[] = [];
  protected dModal: any;
  protected values: {
    [id: string]: { value: string; loading: boolean; error: boolean };
  } = {};
  protected production: boolean;
  private _role?: string;

  private _unsubscribeAll: Subject<any> = new Subject();
  private empSub: any;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  private progressSubject = new BehaviorSubject<number>(0);
  progress$ = this.progressSubject.asObservable();

  private progressInterval!: Subscription;

  protected activeReleaseNote?: iReleaseNotesResponse;
  private releaseNotesGateStarted = false;
  private releaseNotesModalRef: any;
  private dueTaskGateStarted = false;

  private dueTasksModalRef: any;

  setLoadingState(loading: boolean) {
    this.loadingSubject.next(loading);
  }

  setProgress(progress: number) {
    this.progressSubject.next(progress);
  }

  resetProgress() {
    this.progressSubject.next(0);
  }

  get progress() {
    return this.progressSubject.value;
  }

  get loading() {
    return this.loadingSubject.value;
  }

  public onboardingWidgetExpanded: boolean = true;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private _title: Title,
    public _coreConfigService: CoreConfigService,
    private _coreSidebarService: CoreSidebarService,
    private _coreLoadingScreenServ: CoreLoadingScreenService,
    private _coreMenuService: CoreMenuService,
    private _elementRef: ElementRef,
    private _renderer: Renderer2,
    private _taskServ: TasksService,
    private _dataServ: DataService,
    private _modalServ: NgbModal,
    private _todosServ: TodosService,
    private _matDialog: MatDialog,
    private _toastrServ: ToastrService,
    private _http: HttpClient,
    private _router: Router,
    private _route: ActivatedRoute,
    private _authServ: AuthService,
    private _releaseNotesGateServ: ReleaseNotesGateService,
    private _releaseNotesUi: ReleaseNotesUiService,
    private _workspaceServ: WorkspaceService,
    public onboardingService: OnboardingService
  ) {
    const menuDefinitions = [
      { key: 'hr360', menu: hr360Menu },
      { key: 'iTeam', menu: iTeamMenu },
      { key: 'iNest', menu: iNestMenu },
      { key: 'easyInvoice', menu: invoicingMenu },
      { key: 'leadKonnekt', menu: leadKonnektMenu },
      { key: 'customerPortal', menu: customerPortalMenu },
      { key: 'setup', menu: setupMenu },
      { key: 'movementDiary', menu: movementDiaryMenu },
    ];

    menuDefinitions.forEach(({ key, menu }) => {
      if (!this._coreMenuService.hasMenu(key)) {
        this._coreMenuService.register(key, menu);
      }
    });

    const lastMenu = sessionStorage.getItem('lastMenu');
    if (lastMenu) this._coreMenuService.setCurrentMenu(lastMenu);
    this.production = environment.production;
    const vr = environment.version;
    const lvr = localStorage.getItem('version');
    if (lvr && lvr != vr) {
      localStorage.setItem('version', vr);
      localStorage.removeItem('config');
      window.location.reload();
    } else {
      localStorage.setItem('version', vr);
      localStorage.removeItem('config');
    }

    this._router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.setLoadingState(true);
        this.startProgressSimulation();
      } else if (event instanceof RouteConfigLoadEnd) {
        this.stopProgressSimulation();
      }
    });
  }

  startProgressSimulation() {
    this.resetProgress();
    let progress = 0;
    this.progressInterval = interval(150).subscribe(() => {
      if (progress < 95) {
        // Don't go to 100% as it will be set to 100% on load end
        progress += 5; // Increment by 5% every 100ms
        this.setProgress(progress);
      }
    });
  }

  stopProgressSimulation() {
    if (this.progressInterval) {
      this.progressInterval.unsubscribe();
    }
    this.setProgress(100); // Set to 100% on load end
    setTimeout(() => {
      this.setLoadingState(false);
      this.resetProgress();
    }, 100); // Slight delay to show the completed progress bar
  }

  showReminderModal(todo: Todo) {
    this._matDialog.open(ReminderModalComponent, {
      width: '500px',
      data: todo,
      disableClose: false,
    });
  }

  isInit: boolean = true;
  ngOnInit(): void {

    this._coreLoadingScreenServ.hide();
    Waves.init();

    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config: CoreConfig) => {
        this.coreConfig = config;
        // Layout

        // Remove default classes first
        this._elementRef.nativeElement.classList.remove(
          'vertical-layout',
          'vertical-menu-modern',
          'horizontal-layout',
          'horizontal-menu'
        );
        // Add class based on config options
        if (this.coreConfig.layout.type === 'vertical') {
          this._elementRef.nativeElement.classList.add(
            'vertical-layout',
            'vertical-menu-modern'
          );
        } else if (this.coreConfig.layout.type === 'horizontal') {
          this._elementRef.nativeElement.classList.add(
            'horizontal-layout',
            'horizontal-menu'
          );
        }

        // Navbar

        // Remove default classes first
        this._elementRef.nativeElement.classList.remove(
          'navbar-floating',
          'navbar-static',
          'navbar-sticky',
          'navbar-hidden'
        );

        // Add class based on config options
        if (this.coreConfig.layout.navbar.type === 'navbar-static-top') {
          this._elementRef.nativeElement.classList.add('navbar-static');
        } else if (this.coreConfig.layout.navbar.type === 'fixed-top') {
          this._elementRef.nativeElement.classList.add('navbar-sticky');
        } else if (this.coreConfig.layout.navbar.type === 'floating-nav') {
          this._elementRef.nativeElement.classList.add('navbar-floating');
        } else {
          this._elementRef.nativeElement.classList.add('navbar-hidden');
        }

        // Footer
        // Remove default classes first
        this._elementRef.nativeElement.classList.remove(
          'footer-fixed',
          'footer-static',
          'footer-hidden'
        );

        // Add class based on config options
        if (this.coreConfig.layout.footer.type === 'footer-sticky') {
          this._elementRef.nativeElement.classList.add('footer-fixed');
        } else if (this.coreConfig.layout.footer.type === 'footer-static') {
          this._elementRef.nativeElement.classList.add('footer-static');
        } else {
          this._elementRef.nativeElement.classList.add('footer-hidden');
        }

        // Blank layout
        if (
          this.coreConfig.layout.menu.hidden &&
          this.coreConfig.layout.navbar.hidden &&
          this.coreConfig.layout.footer.hidden
        ) {
          this._elementRef.nativeElement.classList.add('blank-page');
          // ! Fix: Transition issue while coming from blank page
          this._renderer.setAttribute(
            this._elementRef.nativeElement.getElementsByClassName(
              'app-content'
            )[0],
            'style',
            'transition:none'
          );
        } else {
          this._elementRef.nativeElement.classList.remove('blank-page');
          // ! Fix: Transition issue while coming from blank page
          setTimeout(() => {
            this._renderer.setAttribute(
              this._elementRef.nativeElement.getElementsByClassName(
                'app-content'
              )[0],
              'style',
              'transition:none'
            );
          }, 0);
          // If navbar hidden
          if (this.coreConfig.layout.navbar.hidden) {
            this._elementRef.nativeElement.classList.add('navbar-hidden');
          }
          // Menu (Vertical menu hidden)
          if (this.coreConfig.layout.menu.hidden) {
            this._renderer.setAttribute(
              this._elementRef.nativeElement,
              'data-col',
              '1-column'
            );
          } else {
            this._renderer.removeAttribute(
              this._elementRef.nativeElement,
              'data-col'
            );
          }
          // Footer
          if (this.coreConfig.layout.footer.hidden) {
            this._elementRef.nativeElement.classList.add('footer-hidden');
          }
        }

        // Skin Class (Adding to body as it requires highest priority)
        if (this.coreConfig.layout.skin) {
          this.document.body.classList.remove(
            'default-layout',
            'bordered-layout',
            'dark-layout',
            'semi-dark-layout'
          );
          this.document.body.classList.add(
            this.coreConfig.layout.skin + '-layout'
          );
        }
      });

    this._title.setTitle(this.coreConfig.app.appTitle);

    // Subscribe to SignalR reminders from TodosService
    this._todosServ.reminderHub.on('ReceiveReminder', (todo: any) => {
      const currentUserId = this._dataServ.employeeValue?.id;

      if (!currentUserId) return;

      // creator check
      const isCreator = todo.createdByUserId === currentUserId;

      // assignee check (IMPORTANT: AssignToId)
      const isAssigned =
        Array.isArray(todo.assignees) &&
        todo.assignees.some((a: any) => a.assignToId === currentUserId);

      if (isCreator || isAssigned) {
        // console.log('Reminder SHOW for:', currentUserId);
        this.showReminderModal(todo);
      } else {
        // console.log('Reminder SKIPPED for:', currentUserId);
      }
    });

    let pui = '';
    this._dataServ.user$.subscribe((v) => {
      if (v?.id && v.id != pui) {
        pui = v.id;
        this._authServ.GetSettingsByUserId();
      }
    });
    let pei = '';
    this._dataServ.employee$.subscribe((v) => {
      // console.log('[ExpiryCheck] employee$ subscription emitted. Value:', v);
      if (v) {
        const wsId = v.workspaceId || v.WorkspaceId || v.workspace_id;
        // console.log('[ExpiryCheck] employee ID:', v.id, 'pei:', pei, 'workspaceId found:', wsId);
        if (v.id != pei) {
          pei = v.id;
          // console.log('[ExpiryCheck] ID changed. Calling _checkDueTasks');
          this._checkDueTasks();
        }
        this._checkWorkspaceExpiry(wsId);
      } else {
        console.log('[ExpiryCheck] employee object is null/undefined');
      }
    });

    this._dataServ.workspaceExpiry$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((expiry) => {
        const active = expiry?.active === true;
        this.workspaceExpiryActive = active;
        this.workspaceExpiryMessage = expiry?.message || '';

        if (active) {
          this._toastrServ.clear();
          this.workspaceExpiryBannerVisible = true;
          this._modalServ.dismissAll();

          if (!this.workspaceExpiryModalRef) {
            setTimeout(() => {
              if (this.workspaceExpiryModalRef) return;
              this.workspaceExpiryModalRef = this._modalServ.open(this.workspaceExpiryModal, {
                backdrop: 'static',
                centered: true,
                keyboard: false,
                size: 'md',
                windowClass: 'workspace-expiry-modal',
              });
              this.workspaceExpiryModalRef.result.finally(() => {
                this.workspaceExpiryModalRef = null;
              });
            }, 0);
          }
        }
      });

    this._router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        take(1),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe(() => this._startDueTaskGate());

    this._router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        take(1),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe(() => this._startReleaseNotesGate());

    this._releaseNotesUi.open$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => this._openActiveReleaseNotes());

    this.onboardingService.stepChanged$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        if (this.onboardingWidgetExpanded) {
          this.scrollToCurrentStep();
        }
      });
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    this.progressInterval?.unsubscribe();
  }

  toggleSidebar(key: string): void {
    this._coreSidebarService.getSidebarRegistry(key).toggleOpen();
  }

  private _checkDueTasks() {
    this.dueTaskLoading = true;
    this.dueTasks = [];
    this.values = {};
    this._taskServ
      .GetDueTasks(this._dataServ.employeeValue?.id, false)
      .pipe(
        map((x) => {
          const res = x.data.map((y) => {
            const z: iDueTaskDto = { ...y, expand: false };
            if (!(z.id! in this.values)) {
              this.values[z.id!] = { error: false, loading: false, value: '' };
            }
            return z;
          });
          return res;
        }),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe({
        next: (res) => {
          this.dueTasks = res;
          // if (res.length > 0) {
          //   this._modalServ.open(this.dueTasksModal, {
          //     backdrop: 'static',
          //     centered: true,
          //     keyboard: false,
          //     size: 'lg',
          //   });
          // }
          if (res.length > 0 && !this.dueTasksModalRef) {
            this.dueTasksModalRef = this._modalServ.open(this.dueTasksModal, {
              backdrop: 'static',
              centered: true,
              keyboard: false,
              size: 'lg',
            });

            this.dueTasksModalRef.result.finally(() => {
              this.dueTasksModalRef = null;
            });
          }
        },
        error: (er) => {
          console.warn(er);
          this._toastrServ.error(
            'Something went wrong while fetching Due Tasks...'
          );
        },
        complete: () => {
          this.dueTaskLoading = false;
        },
      });
  }

  private _startDueTaskGate(): void {
    if (this.dueTaskGateStarted) return;
    this.dueTaskGateStarted = true;

    combineLatest([
      this._dataServ.employee$,
      this._router.events.pipe(
        filter((e) => e instanceof NavigationEnd),
        take(1)
      ),
    ])
      .pipe(
        filter(([emp]) => !!emp?.id),
        observeOn(asyncScheduler),
        take(1),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe(() => this._checkDueTasks());
  }

  private _isBodyEmptyOrNull(body: string) {
    if (!body) {
      return true;
    }

    // Remove leading and trailing whitespaces from the body content
    let bodyContent = body.trim();

    // Check for null or empty body
    if (bodyContent === null || bodyContent === '') {
      return true;
    }

    // Create a temporary DOM element to parse the HTML content
    let tempDiv = document.createElement('div');
    tempDiv.innerHTML = bodyContent;

    // Check if the body contains only an empty paragraph
    let paragraphs = tempDiv.getElementsByTagName('p');
    if (paragraphs.length === 1 && paragraphs[0].innerHTML.trim() === '') {
      return true;
    }

    return false;
  }

  submit(id: string) {
    if (!this.values[id].loading) {
      if (this._isBodyEmptyOrNull(this.values[id].value)) {
        this.values[id].error = true;
        return;
      }
      this.values[id].error = false;
      this.values[id].loading = true;
      const payload: iCommentsRequest = {
        taskId: id,
        devId: this._dataServ.employeeValue?.id,
        devName: `${this._dataServ.employeeValue?.firstName} ${this._dataServ.employeeValue?.lastName}`,
        tlId: this._dataServ.employeeValue?.reportsToId,
        tlName: this._dataServ.employeeValue?.reportsTo,
        devComment: this.values[id].value,
      };

      this._taskServ.AddComments(payload).subscribe({
        next: (con) => {
          this.values[id].loading = false;
          delete this.values[id];
          this.dueTasks = this.dueTasks.filter((x) => x.id !== id);

          if (this.dueTasks.length === 0 && this.dueTasksModalRef) {
            this.dueTasksModalRef.close();
          }
        },
        error: (er) => {
          console.warn(er, 'error adding conversation');
          this._toastrServ.error(
            'Something went wrong while submitting reason!'
          );
        },
      });
    }
  }

  /* --------------------------------
  RELEASE NOTES
  ----------------------------------- */

  private _startReleaseNotesGate(): void {
    if (this.releaseNotesGateStarted) return;
    this.releaseNotesGateStarted = true;

    this._dataServ.user$
      .pipe(
        filter(u => !!u?.id),
        take(1),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe(() => {
        this._releaseNotesGateServ.loadActive();

        this._releaseNotesGateServ.active$
          .pipe(
            filter((note): note is iReleaseNotesResponse => !!note),
            take(1)
          )
          .subscribe(note => {
            this._releaseNotesGateServ.check(activeNote => {
              if (this.releaseNotesModalRef) return;

              this.activeReleaseNote = activeNote;

              this.releaseNotesModalRef = this._modalServ.open(
                this.releaseNotesModal,
                {
                  backdrop: 'static',
                  centered: true,
                  keyboard: false,
                  size: 'lg',
                  windowClass: 'release-notes-modal'
                }
              );

              this.releaseNotesModalRef.result.finally(() => {
                this.releaseNotesModalRef = null;
              });
            });
          });
      });
  }

  private _openActiveReleaseNotes(): void {
    if (this.releaseNotesModalRef) return;

    this._releaseNotesGateServ.loadActive();

    this._releaseNotesGateServ.active$
      .pipe(
        filter((note): note is iReleaseNotesResponse => !!note),
        take(1)
      )
      .subscribe(note => {
        if (this.releaseNotesModalRef) return;

        this.activeReleaseNote = note;

        this.releaseNotesModalRef = this._modalServ.open(
          this.releaseNotesModal,
          {
            backdrop: 'static',
            centered: true,
            size: 'lg',
            windowClass: 'release-notes-modal'
          }
        );

        this.releaseNotesModalRef.result.finally(() => {
          this.releaseNotesModalRef = null;
        });
      });
  }


  closeWorkspaceExpiryModal(modal: any): void {
      this._toastrServ.clear();
      if (this.workspaceExpiryModalRef) {
        this.workspaceExpiryModalRef.close();
        this.workspaceExpiryModalRef = null;
      }
  }
 
  logout(): void {
    this._authServ.Logout();
  }

  closeWorkspaceExpiryBanner(): void {
    this.workspaceExpiryBannerVisible = false;
  }

  markReleaseNotesSeen(modal: any): void {
    if (!this.activeReleaseNote) return;

    this._releaseNotesGateServ.markAsSeen(this.activeReleaseNote);
    modal?.close();
  }

  private _checkWorkspaceExpiry(workspaceId: string) {
    // console.log('[ExpiryCheck] _checkWorkspaceExpiry method invoked with workspaceId:', workspaceId);
    if (!workspaceId) {
      // console.warn('[ExpiryCheck] _checkWorkspaceExpiry aborted: workspaceId is empty/undefined');
      return;
    }

    const alreadyShown = sessionStorage.getItem('workspace_expiry_shown');
    // console.log('[ExpiryCheck] workspace_expiry_shown status:', alreadyShown);
    
    if (alreadyShown === 'true') {
      // console.log('[ExpiryCheck] _checkWorkspaceExpiry aborted: modal already shown in this session');
      return;
    }

    // console.log('[ExpiryCheck] Proceeding to call WorkspaceService.getById for:', workspaceId);
    this._workspaceServ.getById(workspaceId).subscribe({
      next: (workspace: any) => {
        // console.log('[ExpiryCheck] WorkspaceService.getById response payload:', workspace);
        let expiryDateStr = workspace?.activeUntilDate;
        // console.log('[ExpiryCheck] activeUntilDate value:', expiryDateStr);

        if (!expiryDateStr) {
          // console.warn('[ExpiryCheck] No expiry date field found on workspace response:', workspace);
          return;
        }

        this.workspaceExpiryDate = new Date(expiryDateStr);

        this._getServerTime().subscribe((serverNow) => {
          if (!serverNow) {
            this._toastrServ.error('Unable to validate trial expiry using server time. Please try again.');
            return;
          }

          const diffMs = this.workspaceExpiryDate.getTime() - serverNow.getTime();
          // console.log('[ExpiryCheck] Expiry Date parsed:', this.workspaceExpiryDate, 'diffMs:', diffMs);

          if (diffMs <= 0) {
            this.isWorkspaceExpired = true;
            this.workspaceExpiryTimeStr = 'Expired';
          } else {
            this.isWorkspaceExpired = false;
            const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
            const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

            let timeStr = '';
            if (diffDays > 0) {
              timeStr += `${diffDays} days `;
            }
            if (diffHours > 0 || diffDays > 0) {
              timeStr += `${diffHours} hours `;
            }
            timeStr += `${diffMinutes} minutes`;
            this.workspaceExpiryTimeStr = timeStr.trim();
          }
          // console.log('[ExpiryCheck] Expiry remaining string formatted:', this.workspaceExpiryTimeStr, 'Expired status:', this.isWorkspaceExpired);

          this.workspaceExpiry = workspace;
          sessionStorage.setItem('workspace_expiry_shown', 'true');

          const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;
          if (this.isWorkspaceExpired || diffMs <= sevenDaysInMs) {
            // Defer opening the modal to ensure ViewChild is fully initialized
            setTimeout(() => {
              // console.log('[ExpiryCheck] Attempting to open workspace expiry modal. TemplateRef:', this.workspaceExpiryModal);
              if (this.workspaceExpiryModalRef) {
                // console.log('[ExpiryCheck] Modal is already open, ignoring request');
                return;
              }
              this.workspaceExpiryModalRef = this._modalServ.open(this.workspaceExpiryModal, {
                backdrop: 'static',
                centered: true,
                keyboard: false,
                size: 'md',
                windowClass: 'workspace-expiry-modal',
              });
              this.workspaceExpiryModalRef.result.finally(() => {
                // console.log('[ExpiryCheck] Workspace expiry modal closed.');
                this.workspaceExpiryModalRef = null;
              });
            });
          }
        });
      },
      error: (err) => {
        console.error('[ExpiryCheck] Error fetching workspace for expiry check:', err);
      }
    });
  }

  private _getServerTime() {
    return this._http
      .get(`${environment.base_url}/api/Time`, { responseType: 'text' })
      .pipe(
        map((value) => {
          const serverDate = new Date(value);
          return Number.isNaN(serverDate.getTime()) ? null : serverDate;
        }),
        catchError(() => of(null))
      );
  }

  ngAfterViewInit(): void {
    if (this.onboardingWidgetExpanded) {
      this.scrollToCurrentStep();
    }
  }

  toggleOnboardingWidget() {
    this.onboardingWidgetExpanded = !this.onboardingWidgetExpanded;
    if (this.onboardingWidgetExpanded) {
      this.scrollToCurrentStep();
    }
  }

  scrollToCurrentStep() {
    setTimeout(() => {
      const stepIndex = this.onboardingService.currentStep;
      if (this.stepItems && stepIndex >= 0 && stepIndex < this.stepItems.length) {
        const stepEl = this.stepItems.toArray()[stepIndex]?.nativeElement;
        if (stepEl) {
          stepEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }, 150);
  }
}